import Vue from 'vue'
import App from './App.vue'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'

Vue.config.productionTip = false


Vue.use(VideoPlayer);

new Vue({
  render: h => h(App),
}).$mount('#app')
